<mat-card class="answer-sheet-card">
  <mat-card-header class="center card-header">
    <mat-card-title>
      <ng-container i18n="General|Contest question term@@general-contest-question-term">Question</ng-container>
      &thinsp;{{questionMinNumber}} - {{questionMaxNumber}}
    </mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <table *ngIf="answers" mat-table multiTemplateDataRows [dataSource]="answers" class="mat-elevation-z4 full-width">

      <!-- Question Index Column -->
      <ng-container matColumnDef="question_index">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="answer-question-index text-disabled-color">
          {{getQuestionNumber(element.questionIndex)}}
        </td>
      </ng-container>

      <!-- Answers Column -->
      <ng-container *ngFor="let answerIndex of answerIndexes" matColumnDef="{{'answer_' + answerIndex}}">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element"
            class="answer"
            [class.mat-body-2]="isQuestionAnswer(element, answerIndex)"
            [class.answer-sheet-correct-answer]="isUserAnswerCorrect(element, answerIndex)"
            [class.answer-sheet-incorrect-answer]="isAnswerIncorrect(element, answerIndex)"
            [class.answer-sheet-missing-answer]="isAnswerMissing(element, answerIndex)"
            [class.text-disabled-color]="missingQuestionIndexes.includes(element.questionIndex)">
          {{getAnswerLabel(element.questionIndex, answerIndex)}}</td>
      </ng-container>

      <!-- Points Column -->
      <ng-container matColumnDef="points">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element" class="answer-points"
            [class.color-orange]="element.points < 0">{{element.points || 0}}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="columnsToDisplay;" class="hidden"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplay;" class="question-answer-row"></tr>
    </table>
  </mat-card-content>

  <mat-card-footer class="card-footer">
    <span
      i18n="Stats Dashboard|Section points sum title@@stats-dashboard-section-points-sum-title">Section sub-total:</span>
    <span class="fill-space"></span>
    <span class="answer-points mat-body-2">{{sectionSubtotal?.toFixed(2)}}</span>
  </mat-card-footer>
</mat-card>
